import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoginService {
    clientName:string;
    constructor(
        private router: Router,
        private http: HttpClient
    ) {
       
    }
    httpOptions = {
        headers: new HttpHeaders({      
          'Content':"application/json",
          'Content-Type':  'application/json;charset=utf-8',     
        }),         
      };

getClientName() {

    return this.clientName;
    }
    setClientName(name:string) {

        this.clientName=name;
    }

    loginIn(email: string, password: string):Promise<any> 
    {

        var userName = email;
        var password = password;
        var clientId = 'MIRRA';
        var data = "grant_type=password&username=" + userName + "&password=" + password;

  
        return this.http.post<any>(`${environment.apiUrl}` +`/token`, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': '*/*' } })
        .toPromise()
            .then(function (response) {
            let results = response;
              return results;
        },
        err => {
            console.log(err.error);
        })
    }

    logOut():Promise<any> 
    {
        return this.http.get<any>(`${environment.apiUrl}` +`/api/values/logOut`)
        .toPromise()
            .then(function (response) {
                return "success";
        },
        err => {
            console.log(err.error);
        })
    }

    validateUserByToken(token: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}/validateUserByToken/`+token);
      }

      resetPasswordByToken(token: string,password: string): Observable<any> {
        let headers = new HttpHeaders({
          'Content-Type': 'application/json'
       });
       let options = {
          headers: headers
       }
        let data={Password:password,Token:token};
        return this.http.post<any>(`${environment.apiUrl}/resetPasswordByToken`,JSON.stringify(data),options).pipe(map(res => res));
    
     }

     checkUserByEmail(email: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}/api/access/checkUserByEmail/`+email);
      }

      sendPasswordEmail(data:any): Promise<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
         });
         let options = {
            headers: headers
         }
        
        return this.http.post<any>(`${environment.apiUrl}/sendPasswordEmail`, JSON.stringify(data),options)
        .toPromise()
        .then(response => {
          let results = response;
          return results;
        })
    }


    changePassword(data:any): Observable<any>  {      
        return this.http.post<any>(`${environment.apiUrl}/api/users/changePassword`,JSON.stringify(data),this.httpOptions).pipe(map(res => res));
     }

}